module.exports = require('./helpers/bundle-url').getBundleURL('e2rTN') + "logo.c51670a8.svg";